const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['cacheController'] = require('../middleware/cacheController.js')
middleware['cacheController'] = middleware['cacheController'].default || middleware['cacheController']

middleware['history'] = require('../middleware/history.js')
middleware['history'] = middleware['history'].default || middleware['history']

middleware['jivochat'] = require('../middleware/jivochat.js')
middleware['jivochat'] = middleware['jivochat'].default || middleware['jivochat']

middleware['noCache'] = require('../middleware/noCache.js')
middleware['noCache'] = middleware['noCache'].default || middleware['noCache']

middleware['redirects'] = require('../middleware/redirects.js')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

middleware['redirectsFoundation'] = require('../middleware/redirectsFoundation.js')
middleware['redirectsFoundation'] = middleware['redirectsFoundation'].default || middleware['redirectsFoundation']

middleware['robots'] = require('../middleware/robots.js')
middleware['robots'] = middleware['robots'].default || middleware['robots']

middleware['savePrevRoute'] = require('../middleware/savePrevRoute.js')
middleware['savePrevRoute'] = middleware['savePrevRoute'].default || middleware['savePrevRoute']

middleware['scrollToTop'] = require('../middleware/scrollToTop.js')
middleware['scrollToTop'] = middleware['scrollToTop'].default || middleware['scrollToTop']

middleware['setLocale'] = require('../middleware/setLocale.js')
middleware['setLocale'] = middleware['setLocale'].default || middleware['setLocale']

middleware['trailingSlash'] = require('../middleware/trailingSlash.js')
middleware['trailingSlash'] = middleware['trailingSlash'].default || middleware['trailingSlash']

middleware['urlLocale'] = require('../middleware/urlLocale.js')
middleware['urlLocale'] = middleware['urlLocale'].default || middleware['urlLocale']

export default middleware
